/** Canonical user-facing product name shared by the client surfaces. */
export const PRODUCT_NAME = "本义拾光";

/** Temporarily disabled across clients; retain media for a future release. */
export const PRODUCT_FEATURES = Object.freeze({ videoPlayback: false });

export const DIMENSIONS = [
  {
    id: "aware",
    name: "积极觉察",
    short: "觉察",
    tag: "留意当下",
    blurb: "看见生活里被忽略的小变化。",
  },
  {
    id: "strength",
    name: "优势运用",
    short: "优势",
    tag: "发挥所长",
    blurb: "把自己的长处放进今天。",
  },
  {
    id: "relate",
    name: "关系联结",
    short: "联结",
    tag: "靠近彼此",
    blurb: "用一个真实动作连接某个人。",
  },
  {
    id: "resil",
    name: "韧性调适",
    short: "韧性",
    tag: "重新站稳",
    blurb: "在不顺里找到下一步。",
  },
  {
    id: "hope",
    name: "希望行动",
    short: "希望",
    tag: "迈出一步",
    blurb: "为期待的生活做一件小事。",
  },
];

export const DIMENSION_BY_ID = Object.fromEntries(
  DIMENSIONS.map((dimension) => [dimension.id, dimension]),
);

export const isDimensionId = (value) =>
  Object.prototype.hasOwnProperty.call(DIMENSION_BY_ID, value);

/** Business-facing values grouped separately from visual tokens. */
export const businessTokens = {
  productName: PRODUCT_NAME,
  dimensions: DIMENSIONS,
};
